import { CircularProgress } from "@mui/material"
import classNames from "classnames"
import styles from "@/styles/Waitlist.module.scss"
import guestStyles from './GuestLoyaltyLookup.module.css'

export interface GuestLoyaltyLookupProps {
  isGuestLookingUp: boolean
  isGuestLookupSuccess: boolean
  shouldDisplayMatchMessage: boolean
}

export default function GuestLoyaltyLookup({
  isGuestLookingUp,
  isGuestLookupSuccess,
  shouldDisplayMatchMessage,
}: GuestLoyaltyLookupProps) {
  return (
    <>
      <div
        id="party-loyalty-notifier"
        className={classNames(guestStyles['guest-loyalty--notifier'])}
      >
        {isGuestLookingUp ? (
          <CircularProgress
            size={20}
            className={classNames(guestStyles['guest-loyalty--spinner'])}
          />
        ) : (
          <>
            {isGuestLookupSuccess === true && shouldDisplayMatchMessage && (
              <span className={classNames(guestStyles['guest-loyalty--success'])}>
                <img
                  src="/icons/circle-check.svg"
                  alt=""
                  width="20"
                  style={{ marginRight: "4px" }}
                />{" "}
                Match Found
              </span>
            )}
            {isGuestLookupSuccess === false && shouldDisplayMatchMessage && (
              <span className={classNames(guestStyles['guest-loyalty--failure'])}>
                First Visit!
              </span>
            )}
          </>
        )}
      </div>
    </>
  )
}